import { TrendingDown, TrendingUp } from 'lucide-react';
import { pctChange } from '../k2/k2utils';

const Delta = ({ cur, prev, inverse, testId }) => {
  const p = pctChange(cur, prev);
  if (p == null) return <span className="text-xs text-[#94A3B8]" data-testid={testId}>bez srovnání</span>;
  const up = p >= 0;
  const bad = inverse ? up : !up;
  const Icon = up ? TrendingUp : TrendingDown;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 text-xs font-semibold ${bad ? 'text-[#DC2626]' : 'text-[#16A34A]'}`}>
      <Icon className="w-3.5 h-3.5" /> {up ? '+' : ''}{p.toFixed(1)} %
    </span>
  );
};

// tiles: [{ id, label, icon, color, cur, prev, fmt, inverse, note }]
export const KpiStrip = ({ tiles, showCompare }) => (
  <div className={`grid grid-cols-2 gap-3 ${tiles.length > 4 ? 'lg:grid-cols-5' : 'lg:grid-cols-4'}`} data-testid="an-kpis">
    {tiles.map((t) => {
      const Icon = t.icon;
      return (
        <div key={t.id} className="bg-white border border-[#E2E8F0] rounded-2xl p-4 shadow-sm" data-testid={`an-kpi-${t.id}`}>
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-[#57534E]">
            <Icon className="w-4 h-4" style={{ color: t.color }} /> {t.label}
          </div>
          <div className="mt-2 text-2xl font-bold text-[#052E16] font-['Manrope'] tabular-nums" data-testid={`an-kpi-${t.id}-value`}>{t.fmt(t.cur)}</div>
          <div className="mt-1 min-h-[18px]">
            {t.note ? <span className="text-xs text-[#94A3B8]">{t.note}</span>
              : showCompare && t.prev !== undefined && <Delta cur={t.cur} prev={t.prev} inverse={t.inverse} testId={`an-kpi-${t.id}-delta`} />}
          </div>
        </div>
      );
    })}
  </div>
);
